import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Switch,
} from 'antd'
import React, { useEffect, useState } from 'react'
import {
  DateRangeFieldName,
  DateRangeType,
  DateSelect,
  getDateRange,
} from '../../compnents/form/DateSelect'
import { PreCautionParams } from '../../services/PreCaution'
import { ExclamationCircleFilled, SearchOutlined } from '@ant-design/icons'
import styles from './appllication.module.css'
import { stringTrim } from '../../utils/StringUtils'
import { useDispatch, useSelector } from 'react-redux'
import {
  DepartmentDate,
  getProviderTypeList,
  selectDepartData,
} from '../putstorage/putstorageSlice'
import {
  pageDurgsystem,
  selectDurgsystemData,
  selectStorage,
} from '../durgsystem/durgsystemSlice'
import { Category } from '../../models/category'
import { getUserName, sleectUserData } from '../putstorelist/putstorelistSlice'
import { User } from '../../models/user'
import {
  selectChainId,
  selectChainName,
  selectChainType,
  selectShortName,
  selectTenantId,
  selectUserDepartmentId,
  selectUserId,
} from '../../app/applicationSlice'
import { useHistory } from 'react-router-dom'
import {
  getChainListFn,
  getReceiptConfirmFn,
  getReturnDeliveryFn,
  getReturnReceiptFn,
  queryOutboundOperateInventoryFn,
} from './chainSlice'
import { RootDispatch } from '../../app/store'
import { unwrapResult } from '@reduxjs/toolkit'
import { traceRoute } from '../../layouts/layoutSlice'
import moment from 'moment'
import { DateTimeFormatSimple } from '../../models/datetime'

const { Option } = Select

export const Query = (props: {
  activeKey?: any
  exportBtnLoading?: any
  onValueChange: (queries: PreCautionParams) => void
  selectIds?: any
  onClick?: () => void
  exportExcel?: () => void
}) => {
  const [form] = Form.useForm()

  const history = useHistory()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const dispatch = useDispatch<RootDispatch>()

  const departmentData = useSelector(selectDepartData)

  const durgData = useSelector(selectDurgsystemData)

  const userData = useSelector(sleectUserData)

  const userId = useSelector(selectUserId)

  const departmentId = useSelector(selectUserDepartmentId)

  const durgsystemData = useSelector(selectStorage)

  const [chainList, setChainList] = useState<any>([])

  const [providerTypeList, setProviderTypeList] = useState<any>()

  const [head, tail] = getDateRange(DateRangeType.Today)

  const [current, setCurrent] = useState<any>()

  useEffect(() => {
    dispatch(pageDurgsystem(1, 100, 1))
    dispatch(DepartmentDate({ current: 1, size: 500 }))
    if (userId || departmentId) {
      dispatch(getUserName(departmentId))
    }
    if (tenantId == chainId) {
      dispatch(getChainListFn())
        .then(unwrapResult)
        .then((res: any) => {
          setChainList(res?.branchList)
        })
    }
  }, [])

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname + '_' + props?.activeKey) || '{}'
  )

  useEffect(() => {
    if (Object.keys(storageParams).length) {
      form.setFieldsValue({
        ...storageParams,
        timeHead: storageParams?.recepitsDateStart || head,
        timeTail: storageParams?.recepitsDateEnd || tail,
        [DateRangeFieldName]: storageParams?._dateRange || DateRangeType.Today,
        current: current || storageParams?.current ? storageParams?.current : 1,
      })
      form.submit()
    }
  }, [])

  useEffect(() => {
    dispatch(getProviderTypeList())
      .then(unwrapResult)
      .then((v: any) => {
        setProviderTypeList(v)
      })
  }, [])

  return (
    <Form
      form={form}
      name='control-hooks'
      autoComplete='off'
      onFinish={(fs) => {
        props.onValueChange({
          ...storageParams,
          ...fs,
          timeHead: undefined,
          timeTail: undefined,
          recepitsDateStart: fs?.timeHead ? fs?.timeHead : head,
          recepitsDateEnd: fs?.timeTail ? fs?.timeTail : tail,
          current: current,
        })
      }}
    >
      <Row style={{ margin: '0 0 10px 0' }} justify='space-between'>
        <Space wrap={false}>
          <Form.Item name='putNumber' getValueFromEvent={stringTrim} noStyle>
            <Input
              placeholder='输入业务单号'
              allowClear
              prefix={<SearchOutlined />}
              style={{ width: '12rem' }}
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
            />
          </Form.Item>
          <Form.Item name='supplierName' getValueFromEvent={stringTrim} noStyle>
            <Input
              placeholder='输入供应商'
              allowClear
              prefix={<SearchOutlined />}
              style={{ width: '12rem' }}
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
            />
          </Form.Item>
          {tenantId == chainId ? (
            <Form.Item name='branchId' noStyle>
              <Select
                placeholder={'申领门店'}
                allowClear
                showSearch
                style={{ width: '21rem' }}
                dropdownClassName={styles.selects}
                optionFilterProp='children'
                onChange={() => {
                  setCurrent(1)
                  form.submit()
                }}
              >
                {chainList?.map((v: any, i: any) => {
                  return (
                    <Option value={v.id} key={i}>
                      {v.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          ) : (
            <Form.Item name='storehouseId' noStyle>
              <Select
                placeholder={'接收药房'}
                allowClear
                showSearch
                style={{ width: '12rem' }}
                dropdownClassName={styles.selects}
                optionFilterProp='children'
                onChange={() => {
                  setCurrent(1)
                  form.submit()
                }}
              >
                {durgsystemData.map((v: any, i) => {
                  return (
                    <Option value={v.storehouseId} key={i}>
                      {v.storehouseName}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          )}
          <Form.Item name='providerType' noStyle>
            <Select
              placeholder='调拨方'
              allowClear
              showSearch
              style={{ width: '8rem' }}
              dropdownClassName={styles.selects}
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              optionFilterProp='children'
            >
              {providerTypeList?.map((v: any) => {
                return (
                  <Option value={v?.type} key={v?.type}>
                    {v?.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          {tenantId != chainId && (
            <Form.Item name='departmentId' noStyle>
              <Select
                placeholder='业务部门'
                allowClear
                showSearch
                style={{ width: '8rem' }}
                onChange={() => {
                  setCurrent(1)
                  form.submit()
                }}
                dropdownClassName={styles.select}
                // suffixIcon={<CaretDownFilled />}
                optionFilterProp='children'
              >
                {departmentData.map((v: any) => {
                  return (
                    <Option value={v.id} key={v.id}>
                      {v.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          )}
          <Form.Item name='userId' noStyle>
            <Select
              showSearch
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              style={{ width: '8rem' }}
              dropdownClassName={styles.select}
              placeholder={tenantId == chainId ? '审核人员' : '业务人员'}
              allowClear
              // suffixIcon={<CaretDownFilled />}
            >
              {userData.map((v: User) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='storehouseTag' noStyle>
            <Select
              placeholder='状态'
              style={{ width: '8rem' }}
              dropdownClassName={styles.select}
              // suffixIcon={<CaretDownFilled />}
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              allowClear
            >
              {tenantId == chainId ? '' : <Option value='200'>待提交</Option>}
              <Option value='201'>待审核</Option>
              <Option value='202'>审核不通过</Option>
              <Option value='203'>待出库</Option>
              <Option value='204'>已出库</Option>
              <Option value='205'>已入库</Option>
            </Select>
          </Form.Item>
          <Form.Item name='recepitsDateEnd' noStyle>
            <DateSelect
              allowClear={false}
              placeholder='业务日期'
              style={{ width: '8rem' }}
              labelPrefix=''
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              namePrefix='time'
              initialValue={DateRangeType.Today}
            />
          </Form.Item>
          <Button
            htmlType='submit'
            type='primary'
            style={{ marginLeft: '10px' }}
            onClick={() => {
              setCurrent(1)
              form.submit()
            }}
          >
            查询
          </Button>
        </Space>
        <Space>
          {tenantId != chainId ? (
            <Button
              type='primary'
              onClick={() => {
                dispatch(
                  traceRoute({
                    name: '连锁业务',
                    path: '/transferOut',
                    state: {
                      where: ['连锁业务', '申领业务'],
                      backtrace: {
                        name: '连锁业务',
                        path: '/chainClaimBusiness',
                        otherName: '申领单',
                      },
                      category: Category.SLYW,
                      business: true,
                    },
                  })
                )
              }}
            >
              新增申领单
            </Button>
          ) : (
            <></>
          )}
          <Button
            type='primary'
            loading={props?.exportBtnLoading}
            onClick={() => {
              props?.exportExcel && props?.exportExcel()
            }}
          >
            导出
          </Button>
        </Space>
      </Row>
    </Form>
  )
}

export const ProcurementQuery = (props: {
  activeKey?: any
  type: number
  onValueChange: (queries: PreCautionParams) => void
  selectIds?: any
  onClick?: () => void
}) => {
  const [form] = Form.useForm()

  const history = useHistory()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const dispatch = useDispatch<RootDispatch>()

  const departmentData = useSelector(selectDepartData)

  const durgData = useSelector(selectDurgsystemData)

  const userData = useSelector(sleectUserData)

  const userId = useSelector(selectUserId)

  const departmentId = useSelector(selectUserDepartmentId)

  const durgsystemData = useSelector(selectStorage)

  const [chainList, setChainList] = useState<any>([])

  const [head, tail] = getDateRange(DateRangeType.Today)

  const [current, setCurrent] = useState<any>()

  useEffect(() => {
    dispatch(pageDurgsystem(1, 100, 1))
    dispatch(DepartmentDate({ current: 1, size: 500 }))
    if (userId || departmentId) {
      dispatch(getUserName(departmentId))
    }
    if (tenantId == chainId) {
      dispatch(getChainListFn())
        .then(unwrapResult)
        .then((res: any) => {
          setChainList(res?.branchList)
        })
    }
  }, [])

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname + '_' + props?.activeKey) || '{}'
  )

  useEffect(() => {
    if (Object.keys(storageParams).length) {
      form.setFieldsValue({
        ...storageParams,
        timeHead: storageParams?.recepitsDateStart || head,
        timeTail: storageParams?.recepitsDateEnd || tail,
        [DateRangeFieldName]: storageParams?._dateRange || DateRangeType.Today,
        current: current || storageParams?.current ? storageParams?.current : 1,
      })
      form.submit()
    }
  }, [])

  return (
    <Form
      form={form}
      name='control-hooks'
      autoComplete='off'
      onFinish={(fs) => {
        props.onValueChange({
          ...storageParams,
          ...fs,
          timeHead: undefined,
          timeTail: undefined,
          recepitsDateStart: fs?.timeHead ? fs?.timeHead : head,
          recepitsDateEnd: fs?.timeTail ? fs?.timeTail : tail,
          current: current,
        })
      }}
    >
      <Row style={{ margin: '0 0 10px 0' }} justify='space-between'>
        <Space wrap={false}>
          <Form.Item name='param' getValueFromEvent={stringTrim} noStyle>
            <Input
              placeholder='业务单号/供应商'
              allowClear
              prefix={<SearchOutlined />}
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
            />
          </Form.Item>
          <Form.Item name='storehouseTag' noStyle>
            <Select
              placeholder='状态'
              dropdownClassName={styles.select}
              // suffixIcon={<CaretDownFilled />}
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              allowClear
            >
              {tenantId == chainId ? '' : <Option value='200'>待提交</Option>}
              <Option value='207'>待审核</Option>
              <Option value='208'>审核不通过</Option>
              <Option value='209'>审核通过</Option>
              <Option value='210'>已上传</Option>
              <Option value='211'>已登账</Option>
            </Select>
          </Form.Item>
          <Form.Item name='userId' noStyle>
            <Select
              showSearch
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              dropdownClassName={styles.select}
              placeholder='申请人'
              allowClear
              // suffixIcon={<CaretDownFilled />}
            >
              {userData.map((v: User) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='approvedUser' noStyle>
            <Select
              showSearch
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              dropdownClassName={styles.select}
              placeholder='审核人'
              allowClear
              // suffixIcon={<CaretDownFilled />}
            >
              {userData.map((v: User) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='recepitsDate' noStyle>
            <DateSelect
              allowClear={false}
              style={{ width: '8rem' }}
              labelPrefix=''
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              namePrefix='time'
              placeholder='业务日期'
              initialValue={DateRangeType.Today}
            />
          </Form.Item>
          <Button
            type='primary'
            onClick={() => {
              setCurrent(1)
              form.submit()
            }}
          >
            查询
          </Button>
        </Space>
        <Space>
          <Button
            type='primary'
            style={{ marginRight: '10px' }}
            onClick={() => {
              props.type == 1
                ? dispatch(
                    traceRoute({
                      name: '连锁业务',
                      path: '/transferOut',
                      state: {
                        where: ['连锁业务', '采购业务'],
                        backtrace: {
                          name: '连锁业务',
                          path: '/chainClaimBusiness',
                          otherName: '采购单',
                        },
                        category: Category.CGYW,
                        business: true,
                      },
                    })
                  )
                : dispatch(
                    traceRoute({
                      name: '库房工作站',
                      path: '/transferOut',
                      state: {
                        where: ['库房工作站', '采购业务'],
                        backtrace: {
                          name: '单据列表',
                          path: '/procorementBusiness',
                          otherName: '采购单',
                        },
                        category: Category.CGYW,
                        business: true,
                      },
                    })
                  )
            }}
          >
            新增
          </Button>
        </Space>
      </Row>
    </Form>
  )
}

export const AcceptanceQuery = (props: {
  onValueChange: (queries: PreCautionParams) => void
  selectIds?: any
  onClick?: () => void
}) => {
  const [form] = Form.useForm()

  const history = useHistory()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const dispatch = useDispatch<RootDispatch>()

  const departmentData = useSelector(selectDepartData)

  const durgData = useSelector(selectDurgsystemData)

  const userData = useSelector(sleectUserData)

  const userId = useSelector(selectUserId)

  const departmentId = useSelector(selectUserDepartmentId)

  const durgsystemData = useSelector(selectStorage)

  const [chainList, setChainList] = useState<any>([])

  useEffect(() => {
    dispatch(pageDurgsystem(1, 100, 1))
    dispatch(DepartmentDate({ current: 1, size: 500 }))
    if (userId || departmentId) {
      dispatch(getUserName(departmentId))
    }
    if (tenantId == chainId) {
      dispatch(getChainListFn())
        .then(unwrapResult)
        .then((res: any) => {
          setChainList(res?.branchList)
        })
    }
  }, [])

  return (
    <Form
      form={form}
      name='control-hooks'
      autoComplete='off'
      onFinish={(fs) => {
        props.onValueChange({
          ...fs,
        })
      }}
    >
      <Row style={{ margin: '0 0 10px 0' }} justify='space-between'>
        <Space wrap={false}>
          <Form.Item name='keyword' getValueFromEvent={stringTrim} noStyle>
            <Input
              placeholder='供应商名称/助记码'
              allowClear
              prefix={<SearchOutlined />}
              onChange={form.submit}
            />
          </Form.Item>
          <Form.Item name='approvedState' noStyle>
            <Select
              placeholder='状态'
              dropdownClassName={styles.select}
              // suffixIcon={<CaretDownFilled />}
              onChange={form.submit}
              allowClear
            >
              <Option value={0}>待提交</Option>
              <Option value={1}>待审核</Option>
              <Option value={2}>审核通过</Option>
              <Option value={3}>审核不通过</Option>
            </Select>
          </Form.Item>
          <Form.Item name='approvedUserName' noStyle>
            <Select
              showSearch
              onChange={form.submit}
              dropdownClassName={styles.select}
              placeholder='审核人'
              allowClear
              // suffixIcon={<CaretDownFilled />}
            >
              {userData.map((v: User) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='time' noStyle>
            <DateSelect
              style={{ width: '8rem' }}
              labelPrefix=''
              onChange={form.submit}
              namePrefix='time'
              placeholder='创建日期'
              initialValue={DateRangeType.Today}
            />
          </Form.Item>
          <Button
            htmlType='submit'
            type='primary'
            style={{ marginLeft: '10px' }}
            onClick={form.submit}
          >
            查询
          </Button>
        </Space>
        <Space>
          <Button
            type='primary'
            style={{ marginRight: '10px' }}
            onClick={() => {
              dispatch(
                traceRoute({
                  name: '库房工作站',
                  path: '/transferOut',
                  state: {
                    where: ['GSP业务', '验收业务'],
                    backtrace: {
                      name: '单据列表',
                      path: '/acceptanceBusiness',
                      otherName: '验收单',
                    },
                    category: Category.YSYW,
                    business: true,
                  },
                })
              )
            }}
          >
            新增
          </Button>
        </Space>
      </Row>
    </Form>
  )
}

export const ReturnQuery = (props: {
  activeKey?: any
  onValueChange: (queries: PreCautionParams) => void
  selectIds?: any
  onClick?: () => void
}) => {
  const [form] = Form.useForm()

  const history = useHistory()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const dispatch = useDispatch<RootDispatch>()

  const departmentData = useSelector(selectDepartData)

  const durgData = useSelector(selectDurgsystemData)

  const userData = useSelector(sleectUserData)

  const userId = useSelector(selectUserId)

  const departmentId = useSelector(selectUserDepartmentId)

  const durgsystemData = useSelector(selectStorage)

  const [chainList, setChainList] = useState<any>([])

  const [head, tail] = getDateRange(DateRangeType.Today)

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname + '_' + props?.activeKey) || '{}'
  )

  const [current, setCurrent] = useState<any>()

  useEffect(() => {
    dispatch(pageDurgsystem(1, 100, 1))
    dispatch(DepartmentDate({ current: 1, size: 500 }))
    if (userId || departmentId) {
      dispatch(getUserName(departmentId))
    }
    if (tenantId == chainId) {
      dispatch(getChainListFn())
        .then(unwrapResult)
        .then((res: any) => {
          setChainList(res?.branchList)
        })
    }
  }, [])

  useEffect(() => {
    if (Object.keys(storageParams).length) {
      form.setFieldsValue({
        ...storageParams,
        timeHead: storageParams?.recepitsDateStart || head,
        timeTail: storageParams?.recepitsDateEnd || tail,
        [DateRangeFieldName]: storageParams?._dateRange || DateRangeType.Today,
        current: current || storageParams?.current ? storageParams?.current : 1,
      })
      form.submit()
    }
  }, [])

  return (
    <Form
      form={form}
      name='control-hooks'
      autoComplete='off'
      onFinish={(fs) => {
        props.onValueChange({
          ...storageParams,
          ...fs,
          timeHead: undefined,
          timeTail: undefined,
          recepitsDateStart: fs?.timeHead ? fs?.timeHead : head,
          recepitsDateEnd: fs?.timeTail ? fs?.timeTail : tail,
          current: current,
        })
      }}
    >
      <Row style={{ margin: '0 0 10px 0' }} justify='space-between'>
        <Space wrap={false}>
          <Form.Item name='putNumber' getValueFromEvent={stringTrim} noStyle>
            <Input
              placeholder='供应商名称/助记码'
              allowClear
              prefix={<SearchOutlined />}
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
            />
          </Form.Item>
          <Form.Item name='storehouseTag' noStyle>
            <Select
              placeholder='状态'
              dropdownClassName={styles.select}
              // suffixIcon={<CaretDownFilled />}
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              allowClear
            >
              {tenantId == chainId ? '' : <Option value='200'>待提交</Option>}
              <Option value='207'>待审核</Option>
              <Option value='208'>审核不通过</Option>
              <Option value='209'>审核通过</Option>
              <Option value='210'>已上传</Option>
              <Option value='211'>已登账</Option>
            </Select>
          </Form.Item>
          <Form.Item name='userId' noStyle>
            <Select
              showSearch
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              dropdownClassName={styles.select}
              placeholder='申请人'
              allowClear
              // suffixIcon={<CaretDownFilled />}
            >
              {userData.map((v: User) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='approvedUser' noStyle>
            <Select
              showSearch
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              dropdownClassName={styles.select}
              placeholder='审核人'
              allowClear
              // suffixIcon={<CaretDownFilled />}
            >
              {userData.map((v: User) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='recepitsDateEnd' noStyle>
            <DateSelect
              allowClear={false}
              style={{ width: '8rem' }}
              labelPrefix=''
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              namePrefix='time'
              placeholder='业务日期'
              initialValue={DateRangeType.Today}
            />
          </Form.Item>
          <Button
            htmlType='submit'
            type='primary'
            style={{ marginLeft: '10px' }}
            onClick={() => {
              setCurrent(1)
              form.submit()
            }}
          >
            查询
          </Button>
        </Space>
        <Space>
          <Button
            type='primary'
            style={{ marginRight: '10px' }}
            onClick={() => {
              dispatch(
                traceRoute({
                  name: '连锁业务',
                  path: '/transferOut',
                  state: {
                    where: ['连锁业务', '退货业务'],
                    backtrace: {
                      name: '连锁业务',
                      path: '/chainClaimBusiness',
                      otherName: '退货单',
                    },
                    category: Category.CGTHYW,
                    business: true,
                  },
                })
              )
            }}
          >
            新增
          </Button>
        </Space>
      </Row>
    </Form>
  )
}

export const ReturnBranchQuery = (props: {
  activeKey?:any
  onValueChange: (queries: PreCautionParams) => void
  selectIds?: any
  onClick?: () => void
}) => {
  const [form] = Form.useForm()

  const history = useHistory()

  const dispatch = useDispatch<RootDispatch>()

  const departmentData = useSelector(selectDepartData)

  const durgData = useSelector(selectDurgsystemData)

  const userData = useSelector(sleectUserData)

  const userId = useSelector(selectUserId)

  const departmentId = useSelector(selectUserDepartmentId)

  const durgsystemData = useSelector(selectStorage)

  const [head, tail] = getDateRange(DateRangeType.Today)

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname + '_' + props?.activeKey) || '{}'
  )

  const [current, setCurrent] = useState<any>()

  useEffect(() => {
    dispatch(pageDurgsystem(1, 100, 1))
    dispatch(DepartmentDate({ current: 1, size: 500 }))
    if (userId || departmentId) {
      dispatch(getUserName(departmentId))
    }
  }, [])

  useEffect(() => {
    if (Object.keys(storageParams).length) {
      form.setFieldsValue({
        ...storageParams,
        timeHead: storageParams?.recepitsDateStart || head,
        timeTail: storageParams?.recepitsDateEnd || tail,
        [DateRangeFieldName]: storageParams?._dateRange || DateRangeType.Today,
        current: current || storageParams?.current ? storageParams?.current : 1,
      })
      form.submit()
    }
  }, [])

  return (
    <Form
      form={form}
      name='control-hooks'
      autoComplete='off'
      onFinish={(fs) => {
        props.onValueChange({
          ...storageParams,
          ...fs,
          timeHead: undefined,
          timeTail: undefined,
          recepitsDateStart: fs?.timeHead ? fs?.timeHead : head,
          recepitsDateEnd: fs?.timeTail ? fs?.timeTail : tail,
          current: current,
        })
      }}
    >
      <Row style={{ margin: '0 0 10px 0' }} justify='space-between'>
        <Space wrap={false}>
          <Form.Item name='putNumber' getValueFromEvent={stringTrim} noStyle>
            <Input
              placeholder='输入业务单号'
              allowClear
              prefix={<SearchOutlined />}
              style={{ width: '12rem' }}
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
            />
          </Form.Item>
          <Form.Item name='storehouseId' noStyle>
            <Select
              placeholder={'接收药房'}
              allowClear
              showSearch
              dropdownClassName={styles.select}
              optionFilterProp='children'
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
            >
              {durgsystemData.map((v: any, i) => {
                return (
                  <Option value={v.storehouseId} key={i}>
                    {v.storehouseName}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='departmentId' noStyle>
            <Select
              placeholder='业务部门'
              allowClear
              showSearch
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              dropdownClassName={styles.select}
              // suffixIcon={<CaretDownFilled />}
              optionFilterProp='children'
            >
              {departmentData.map((v: any) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='userId' noStyle>
            <Select
              showSearch
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              dropdownClassName={styles.select}
              placeholder={'业务人员'}
              allowClear
            >
              {userData.map((v: User) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='storehouseTag' noStyle>
            <Select
              placeholder='状态'
              dropdownClassName={styles.select}
              // suffixIcon={<CaretDownFilled />}
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              allowClear
            >
              <Option value='200'>待提交</Option>
              <Option value='201'>待审核</Option>
              <Option value='202'>审核不通过</Option>
              <Option value='203'>待出库</Option>
              <Option value='204'>已出库</Option>
              <Option value='205'>已入库</Option>
            </Select>
          </Form.Item>
          <Form.Item name='recepitsDateEnd' noStyle>
            <DateSelect
              allowClear={false}
              style={{ width: '8rem' }}
              labelPrefix=''
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              namePrefix='time'
              placeholder='业务日期'
              initialValue={DateRangeType.Today}
            />
          </Form.Item>
          <Button
            htmlType='submit'
            type='primary'
            style={{ marginLeft: '10px' }}
            onClick={() => {
              setCurrent(1)
              form.submit()
            }}
          >
            查询
          </Button>{' '}
        </Space>{' '}
        <Space>
          <Button
            type='primary'
            style={{ marginRight: '10px' }}
            onClick={() => {
              dispatch(
                traceRoute({
                  name: '连锁业务',
                  path: '/transferOut',
                  state: {
                    where: ['连锁业务', '退货业务'],
                    backtrace: {
                      name: '连锁业务',
                      path: '/chainClaimBusiness',
                      otherName: '退货单',
                    },
                    category: Category.FDTHYW,
                    business: true,
                  },
                })
              )
            }}
          >
            新增退货单
          </Button>
        </Space>
      </Row>
    </Form>
  )
}

export const ReturnHeadQuery = (props: {
  activeKey?: any
  onValueChange: (queries: PreCautionParams) => void
  selectIds?: any
  onClick?: () => void
}) => {
  const [form] = Form.useForm()

  const history = useHistory()

  const dispatch = useDispatch<RootDispatch>()

  const departmentData = useSelector(selectDepartData)

  const durgData = useSelector(selectDurgsystemData)

  const userData = useSelector(sleectUserData)

  const userId = useSelector(selectUserId)

  const departmentId = useSelector(selectUserDepartmentId)

  const durgsystemData = useSelector(selectStorage)

  const [chainList, setChainList] = useState<any>([])

  const [head, tail] = getDateRange(DateRangeType.Today)

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname + '_' + props?.activeKey) || '{}'
  )

  const [current, setCurrent] = useState<any>()

  useEffect(() => {
    dispatch(pageDurgsystem(1, 100, 1))
    dispatch(DepartmentDate({ current: 1, size: 500 }))
    if (userId || departmentId) {
      dispatch(getUserName(departmentId))
    }
    dispatch(getChainListFn())
      .then(unwrapResult)
      .then((res: any) => {
        setChainList(res?.branchList)
      })
  }, [])

  useEffect(() => {
    if (Object.keys(storageParams).length) {
      form.setFieldsValue({
        ...storageParams,
        timeHead: storageParams?.recepitsDateStart || head,
        timeTail: storageParams?.recepitsDateEnd || tail,
        [DateRangeFieldName]: storageParams?._dateRange || DateRangeType.Today,
        current: current || storageParams?.current ? storageParams?.current : 1,
      })
      form.submit()
    }
  }, [])

  return (
    <Form
      form={form}
      name='control-hooks'
      autoComplete='off'
      onFinish={(fs) => {
      props.onValueChange({
          ...storageParams,
          ...fs,
          timeHead: undefined,
          timeTail: undefined,
          recepitsDateStart: fs?.timeHead ? fs?.timeHead : head,
          recepitsDateEnd: fs?.timeTail ? fs?.timeTail : tail,
          current: current,
        })
      }}
    >
      <Row style={{ margin: '0 0 10px 0' }} justify='space-between'>
        <Space wrap={false}>
          <Form.Item name='putNumber' getValueFromEvent={stringTrim} noStyle>
            <Input
              placeholder='输入业务单号'
              allowClear
              prefix={<SearchOutlined />}
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
            />
          </Form.Item>
          <Form.Item name='branchId' noStyle>
            <Select
              placeholder={'退货门店'}
              allowClear
              showSearch
              dropdownClassName={styles.select}
              optionFilterProp='children'
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
            >
              {chainList?.map((v: any, i: any) => {
                return (
                  <Option value={v.id} key={i}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='departmentId' noStyle>
            <Select
              placeholder='业务部门'
              allowClear
              showSearch
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              dropdownClassName={styles.select}
              // suffixIcon={<CaretDownFilled />}
              optionFilterProp='children'
            >
              {departmentData.map((v: any) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='userId' noStyle>
            <Select
              showSearch
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              dropdownClassName={styles.select}
              placeholder={'业务人员'}
              allowClear
            >
              {userData.map((v: User) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.name}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='storehouseTag' noStyle>
            <Select
              placeholder='状态'
              dropdownClassName={styles.select}
              // suffixIcon={<CaretDownFilled />}
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              allowClear
            >
              <Option value='201'>待审核</Option>
              <Option value='202'>审核不通过</Option>
              <Option value='203'>待出库</Option>
              <Option value='204'>已出库</Option>
              <Option value='205'>已入库</Option>
            </Select>
          </Form.Item>
          <Form.Item name='recepitsDateEnd' noStyle>
            <DateSelect
              allowClear={false}
              style={{ width: '8rem' }}
              labelPrefix=''
              onChange={() => {
                setCurrent(1)
                form.submit()
              }}
              namePrefix='time'
              placeholder='业务日期'
              initialValue={DateRangeType.Today}
            />
          </Form.Item>
          <Button
            htmlType='submit'
            type='primary'
            onClick={() => {
              setCurrent(1)
              form.submit()
            }}
          >
            查询
          </Button>
        </Space>
      </Row>
    </Form>
  )
}

export const DetailQuery = (props: {
  category: Category
  Detail: any
  selectId?: number
  onRefuse?: () => void
  onOK?: () => void
  onSubmit?: () => void
  onCopy?: () => void
  onSearch?: () => void
  onPutInto?: () => void
  onUpload?: () => void
  print?: () => void
  exportExcel?: () => void
  exportExcelFB?: () => void
  onAcceptance?: () => void
  onStorage?: () => void
}) => {
  const history = useHistory()

  const [form] = Form.useForm()

  const chainType = useSelector(selectChainType)

  const dispatch = useDispatch<RootDispatch>()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const departmentData = useSelector(selectDepartData)

  const userData = useSelector(sleectUserData)

  const shortName = useSelector(selectShortName)

  const chainName = useSelector(selectChainName)

  const [normalGysNameFlag, setNormalGysNameFlag] = useState<any>(false)

  useEffect(() => {
    dispatch(DepartmentDate({ current: 1, size: 1000 }))
  }, [])

  useEffect(() => {
    const normalGysName = localStorage.getItem('normalGysName')
    if (normalGysName) {
      setNormalGysNameFlag(normalGysName == 'true' ? true : false)
    }
  }, [])

  return (
    <>
      {props?.category == Category.CGYW ||
      props?.category == Category.CGTHYW ? (
        <>
          <Row
            className={styles.titletext}
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Col
              span={24}
              style={{
                fontSize: '18px',
                fontWeight: 'bold',
                paddingLeft: '10px',
                width: '100%',
                height: '30px',
              }}
            >
              <div style={{ display: 'flex' }}>
                <span
                  style={{
                    width: '2px',
                    height: '16px',
                    background: ' #0052D9',
                    position: 'relative',
                    top: '6px',
                    marginRight: '10px',
                  }}
                ></span>
                {props?.category == Category.CGYW
                  ? '采购业务单据'
                  : '退货业务单据'}
              </div>
              {props?.Detail?.storehouseTag == '206' && (
                <Button
                  type='primary'
                  style={{
                    float: 'right',
                    position: 'relative',
                    top: '-28px',
                    marginLeft: 10,
                  }}
                  onClick={() => {
                    props?.Detail?.type == 1
                      ? dispatch(
                          traceRoute({
                            name: '连锁业务',
                            path: '/transferOut',
                            state: {
                              where: ['连锁业务', '采购业务'],
                              backtrace: {
                                name: '连锁业务',
                                path: '/chainClaimBusiness',
                                otherName: '采购单',
                              },
                              category: Category.CGYW,
                              business: true,
                              detail: {
                                ...props.Detail,
                                departmentId: Number(
                                  props.Detail?.departmentId
                                ),
                              },
                            },
                          })
                        )
                      : dispatch(
                          traceRoute({
                            name: '库房工作站',
                            path: '/transferOut',
                            state: {
                              where: ['库房工作站', '采购业务'],
                              backtrace: {
                                name: '单据列表',
                                path: '/procorementBusiness',
                                otherName: '采购单',
                              },
                              category: Category.CGYW,
                              business: true,
                              detail: {
                                ...props?.Detail,
                                departmentId: Number(
                                  props.Detail?.departmentId
                                ),
                              },
                            },
                          })
                        )
                  }}
                >
                  修改业务单据
                </Button>
              )}

              {props?.category == Category.CGYW &&
                props?.Detail?.storehouseTag == '206' && (
                  <Button
                    type='primary'
                    style={{
                      float: 'right',
                      position: 'relative',
                      top: '-28px',
                      marginLeft: 10,
                    }}
                    onClick={props?.onSubmit}
                  >
                    采购提交
                  </Button>
                )}
              {props?.category == Category.CGYW &&
                props?.Detail?.storehouseTag == '206' && (
                  <Button
                    type='primary'
                    ghost
                    style={{
                      float: 'right',
                      position: 'relative',
                      top: '-28px',
                      background: '#f79d2e',
                      color: '#ffffff',
                      border: 'none',
                    }}
                    onClick={props?.onCopy}
                  >
                    从申领单复制
                  </Button>
                )}

              {props?.category == Category.CGTHYW &&
                props?.Detail?.storehouseTag == '206' && (
                  <Button
                    type='primary'
                    style={{
                      float: 'right',
                      position: 'relative',
                      top: '-28px',
                    }}
                    onClick={props?.onSubmit}
                  >
                    退货提交
                  </Button>
                )}
              {props?.Detail?.storehouseTag == '207' && (
                <>
                  <Button
                    type='primary'
                    danger
                    style={{
                      float: 'right',
                      marginLeft: 10,
                      position: 'relative',
                      top: '-28px',
                    }}
                    onClick={props?.onRefuse}
                  >
                    拒绝
                  </Button>
                  <Button
                    type='primary'
                    style={{
                      float: 'right',
                      position: 'relative',
                      top: '-28px',
                    }}
                    onClick={props?.onOK}
                  >
                    通过
                  </Button>
                </>
              )}
              {props?.Detail?.storehouseTag == '209' && chainType == 1 && (
                <Button
                  type='primary'
                  style={{ float: 'right', position: 'relative', top: '-28px' }}
                  onClick={props?.onUpload}
                >
                  上传
                </Button>
              )}
              {props?.Detail?.storehouseTag == '209' &&
                chainType == 0 &&
                props?.Detail?.stockInInventoryReceiptsId < 0 && (
                  <Button
                    // type='primary'
                    style={{
                      float: 'right',
                      position: 'relative',
                      top: '-28px',
                      background: '#FFA037',
                      color: '#ffffff',
                      border: 'none',
                    }}
                    onClick={props?.onStorage}
                  >
                    生成入库单
                  </Button>
                )}
              {props?.Detail?.storehouseTag == '209' &&
                chainType == 0 &&
                props?.Detail?.purchaseAcceptanceId < 0 && (
                  <Button
                    style={{
                      float: 'right',
                      position: 'relative',
                      top: '-28px',
                      marginRight: 10,
                      background: '#FFA037',
                      color: '#ffffff',
                      border: 'none',
                    }}
                    onClick={props?.onAcceptance}
                  >
                    生成验收单
                  </Button>
                )}
              {props?.category == Category.CGYW &&
                props?.Detail?.storehouseTag == '210' && (
                  <Button
                    type='primary'
                    style={{
                      float: 'right',
                      position: 'relative',
                      top: '-28px',
                    }}
                    onClick={props.onPutInto}
                  >
                    入库确认
                  </Button>
                )}
              {props?.category == Category.CGYW &&
                props?.Detail?.storehouseTag == '211' && (
                  <Button
                    type='primary'
                    style={{
                      float: 'right',
                      position: 'relative',
                      top: '-28px',
                    }}
                    onClick={props.onPutInto}
                  >
                    入库查询
                  </Button>
                )}
              {props?.category == Category.CGTHYW &&
                props?.Detail?.storehouseTag == '210' && (
                  <Button
                    type='primary'
                    style={{
                      float: 'right',
                      position: 'relative',
                      top: '-28px',
                    }}
                    onClick={() => {
                      Modal.confirm({
                        centered: true,
                        title: '确认操作',
                        content: (
                          <div>
                            <ExclamationCircleFilled
                              style={{ color: '#FFAE55', fontSize: 18 }}
                            />
                            &nbsp;是否确认退货？
                          </div>
                        ),
                        okText: '确认',
                        cancelText: '取消',
                        icon: null,
                        onOk: () => {
                          dispatch(
                            queryOutboundOperateInventoryFn(props?.selectId)
                          )
                            .then(unwrapResult)
                            .then(() => {
                              notification.success({
                                message: '操作成功',
                              })
                              history.push({
                                pathname: '/chainClaimBusiness',
                              })
                            })
                        },
                      })
                    }}
                  >
                    退货确认
                  </Button>
                )}
            </Col>
          </Row>
          <Row
            className={styles.contentTitle}
            style={{
              marginTop: '10px',
              lineHeight: '40px',
              paddingLeft: '20px',
              marginBottom: '10px',
              fontSize: '18px',
            }}
          >
            <Col span={6}>业务单号：{props.Detail?.putNumber}</Col>
            <Col span={6}>供应商：{props.Detail?.supplierName}</Col>
            <Col span={6}>申请部门：{props.Detail?.departmentName}</Col>
            <Col span={6}>申请人：{props.Detail?.userName}</Col>
            {/* <Col span={24}></Col> */}
          </Row>
        </>
      ) : props?.category == Category.FDTHYW ||
        props?.category == Category.ZDTHYW ? (
        <>
          <Row
            className={styles.titletext}
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Col
              span={24}
              style={{
                fontSize: '18px',
                fontWeight: 'bold',
                paddingLeft: '10px',
                width: '100%',
                height: '30px',
              }}
            >
              <div style={{ display: 'flex' }}>
                <span
                  style={{
                    width: '2px',
                    height: '16px',
                    background: ' #0052D9',
                    position: 'relative',
                    top: '6px',
                    marginRight: '10px',
                  }}
                ></span>
                {tenantId == chainId ? '门店退货' : '退货'}业务单据
              </div>
              {tenantId != chainId && props?.Detail?.storehouseTag == '200' && (
                <Button
                  type='primary'
                  style={{ float: 'right', position: 'relative', top: '-28px' }}
                  onClick={props?.onSubmit}
                >
                  退货提交
                </Button>
              )}
              {tenantId != chainId && props?.Detail?.storehouseTag == '203' && (
                <Button
                  type='primary'
                  style={{ float: 'right', position: 'relative', top: '-28px' }}
                  onClick={() => {
                    Modal.confirm({
                      centered: true,
                      title: '确认操作',
                      content: (
                        <div>
                          <ExclamationCircleFilled
                            style={{ color: '#FFAE55', fontSize: 18 }}
                          />
                          &nbsp;是否确认出库？
                        </div>
                      ),
                      okText: '确认',
                      cancelText: '取消',
                      icon: null,
                      onOk: () => {
                        dispatch(getReturnReceiptFn(props?.selectId))
                          .then(unwrapResult)
                          .then(() => {
                            notification.success({
                              message: '操作成功',
                            })
                            history.push({
                              pathname: '/chainClaimBusiness',
                            })
                          })
                      },
                    })
                  }}
                >
                  出库确认
                </Button>
              )}
              {tenantId == chainId && props?.Detail?.storehouseTag == '204' && (
                <Button
                  type='primary'
                  style={{ float: 'right', position: 'relative', top: '-28px' }}
                  onClick={props.onPutInto}
                >
                  入库确认
                </Button>
              )}
              {tenantId == chainId && props?.Detail?.storehouseTag == '205' && (
                <Button
                  type='primary'
                  style={{ float: 'right', position: 'relative', top: '-28px' }}
                  onClick={props?.onSearch}
                >
                  入库查询
                </Button>
              )}
              {tenantId == chainId && props?.Detail?.storehouseTag == '201' && (
                <>
                  <Button
                    type='primary'
                    danger
                    style={{
                      float: 'right',
                      marginLeft: 10,
                      position: 'relative',
                      top: '-28px',
                    }}
                    onClick={props?.onRefuse}
                  >
                    拒绝
                  </Button>
                  <Button
                    type='primary'
                    style={{
                      float: 'right',
                      position: 'relative',
                      top: '-28px',
                    }}
                    onClick={props?.onOK}
                  >
                    通过
                  </Button>
                </>
              )}
            </Col>
          </Row>
          <Row
            className={styles.contentTitle}
            style={{
              marginTop: '10px',
              lineHeight: '40px',
              paddingLeft: '20px',
              marginBottom: '10px',
              fontSize: '18px',
            }}
          >
            <Col span={6}>业务单号：{props.Detail?.putNumber}</Col>
            {tenantId == chainId ? (
              <>
                <Col span={6}>
                  收货方：
                  {props.Detail?.target}
                </Col>
                <Col span={12}>
                  退货门店：
                  {props.Detail?.source}
                </Col>
              </>
            ) : (
              <>
                <Col span={6}>
                  收货门店：
                  {props.Detail?.source}
                </Col>
                <Col span={12}>
                  退货门店：
                  {shortName}
                </Col>
              </>
            )}
            <Col span={6}>
              业务部门：
              {tenantId == chainId
                ? props.Detail?.sourceDepartmentName
                : props.Detail?.departmentName}
            </Col>
            <Col span={6}>
              业务人员：
              {tenantId == chainId
                ? props.Detail?.sourceUserName
                : props.Detail?.userName}
            </Col>
            {/* <Col span={24}></Col> */}
          </Row>
        </>
      ) : props?.category == Category.YSYW ? (
        <>
          <Row
            className={styles.titletext}
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Col
              span={24}
              style={{
                fontSize: '18px',
                fontWeight: 'bold',
                paddingLeft: '10px',
                width: '100%',
                height: '30px',
              }}
            >
              <div style={{ display: 'flex' }}>
                <span
                  style={{
                    width: '2px',
                    height: '16px',
                    background: ' #0052D9',
                    position: 'relative',
                    top: '6px',
                    marginRight: '10px',
                  }}
                ></span>
                验收业务单据
              </div>
              {props?.Detail?.approvedState == 0 && (
                <>
                  <Button
                    type='primary'
                    style={{
                      float: 'right',
                      position: 'relative',
                      top: '-28px',
                      marginLeft: 10,
                    }}
                    onClick={() => {
                      dispatch(
                        traceRoute({
                          name: '库房工作站',
                          path: '/transferOut',
                          state: {
                            where: ['GSP业务', '验收业务'],
                            backtrace: {
                              name: '单据列表',
                              path: '/acceptanceBusiness',
                              otherName: '验收单',
                            },
                            category: Category.YSYW,
                            business: true,
                            detail: {
                              ...props.Detail,
                            },
                          },
                        })
                      )
                    }}
                  >
                    修改业务单据
                  </Button>
                  <Button
                    type='primary'
                    style={{
                      float: 'right',
                      position: 'relative',
                      top: '-28px',
                      marginLeft: 10,
                    }}
                    onClick={props?.onSubmit}
                  >
                    验收提交
                  </Button>
                  <Button
                    type='primary'
                    ghost
                    style={{
                      float: 'right',
                      position: 'relative',
                      top: '-28px',
                      background: '#f79d2e',
                      color: '#ffffff',
                      border: 'none',
                    }}
                    onClick={props?.onCopy}
                  >
                    从采购单复制
                  </Button>
                </>
              )}

              {props?.Detail?.approvedState == 1 && (
                <>
                  <Button
                    type='primary'
                    danger
                    style={{
                      float: 'right',
                      marginLeft: 10,
                      position: 'relative',
                      top: '-28px',
                    }}
                    onClick={props?.onRefuse}
                  >
                    拒绝
                  </Button>
                  <Button
                    type='primary'
                    style={{
                      float: 'right',
                      position: 'relative',
                      top: '-28px',
                    }}
                    onClick={props?.onOK}
                  >
                    通过
                  </Button>
                </>
              )}
              {props?.Detail?.approvedState == 2 &&
                props?.Detail?.stockInInventoryReceiptsId < 0 && (
                  <>
                    <Button
                      type='primary'
                      style={{
                        float: 'right',
                        position: 'relative',
                        top: '-28px',
                        background: '#FFA037',
                        color: '#ffffff',
                        border: 'none',
                      }}
                      onClick={props?.onStorage}
                    >
                      生成入库单
                    </Button>
                  </>
                )}
            </Col>
          </Row>
          <Row
            className={styles.contentTitle}
            style={{
              marginTop: '10px',
              lineHeight: '40px',
              paddingLeft: '20px',
              marginBottom: '10px',
              fontSize: '18px',
            }}
          >
            <Col span={6}>业务单号：{props.Detail?.putNumber}</Col>
            <Col span={6}>供应商：{props.Detail?.supplierName}</Col>
            <Col span={6}>收货单号：{props.Detail?.arrivalOrderNumber}</Col>
            <Col span={6}>
              到货日期：
              {moment(props.Detail?.arrivalDate).format(DateTimeFormatSimple)}
            </Col>
            {/* <Col span={24}></Col> */}
          </Row>
        </>
      ) : (
        <>
          <Row
            className={styles.titletext}
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Col
              span={24}
              style={{
                fontSize: '18px',
                fontWeight: 'bold',
                paddingLeft: '10px',
                width: '100%',
                height: '30px',
              }}
            >
              <Row>
                <Col span={14}>
                  <div style={{ display: 'flex' }}>
                    <span
                      style={{
                        width: '2px',
                        height: '16px',
                        background: ' #0052D9',
                        position: 'relative',
                        top: '6px',
                        marginRight: '10px',
                      }}
                    ></span>
                    {tenantId == chainId ? '调拨出库' : '申领'}业务单据
                  </div>
                </Col>
                <Col
                  span={10}
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                >
                  {tenantId != chainId &&
                    props?.Detail?.storehouseTag == '200' && (
                      <Button
                        type='primary'
                        style={{
                          marginLeft: '10px',
                        }}
                        onClick={props?.onSubmit}
                      >
                        申领提交
                      </Button>
                    )}

                  {tenantId != chainId &&
                    props?.Detail?.storehouseTag == '204' && (
                      <Button
                        type='primary'
                        style={{
                          marginLeft: '10px',
                        }}
                        onClick={() => {
                          Modal.confirm({
                            centered: true,
                            title: '确认操作',
                            content: (
                              <div>
                                <ExclamationCircleFilled
                                  style={{ color: '#FFAE55', fontSize: 18 }}
                                />
                                &nbsp;是否确认入库？
                              </div>
                            ),
                            okText: '确认',
                            cancelText: '取消',
                            icon: null,
                            onOk: () => {
                              dispatch(getReceiptConfirmFn(props?.selectId))
                                .then(unwrapResult)
                                .then(() => {
                                  notification.success({
                                    message: '操作成功',
                                  })
                                  history.push({
                                    pathname: '/chainClaimBusiness',
                                  })
                                })
                            },
                          })
                        }}
                      >
                        入库确认
                      </Button>
                    )}
                  {tenantId == chainId &&
                    props?.Detail?.storehouseTag == '201' && (
                      <>
                        <Button
                          type='primary'
                          danger
                          style={{
                            marginLeft: '10px',
                          }}
                          onClick={props?.onRefuse}
                        >
                          拒绝
                        </Button>
                        <Button
                          type='primary'
                          style={{
                            marginLeft: '10px',
                          }}
                          onClick={props?.onOK}
                        >
                          通过
                        </Button>
                      </>
                    )}
                  {/* {tenantId == chainId && (
                    <Button
                      type='primary'
                      style={{
                        marginLeft: '10px',
                      }}
                      onClick={props?.print}
                    >
                      打印
                    </Button>
                  )}

                  {tenantId == chainId ? (
                    props?.Detail?.storehouseTag != '201' && (
                      <Button
                        htmlType='submit'
                        type='primary'
                        style={{ marginLeft: '10px' }}
                        onClick={() => {
                          props?.exportExcel && props?.exportExcel()
                        }}
                      >
                        导出
                      </Button>
                    )
                  ) : (
                    <Button
                      htmlType='submit'
                      type='primary'
                      style={{ marginLeft: '10px' }}
                      onClick={() => {
                        props?.exportExcelFB && props?.exportExcelFB()
                      }}
                    >
                      导出
                    </Button>
                  )} */}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row
            className={styles.contentTitle}
            style={{
              marginTop: '10px',
              lineHeight: '40px',
              paddingLeft: '20px',
              marginBottom: '10px',
              fontSize: '18px',
            }}
          >
            <Col span={6}>业务单号：{props.Detail?.putNumber}</Col>
            {tenantId == chainId ? (
              <>
                <Col span={6}>
                  调拨方：
                  {props.Detail?.source}
                </Col>
                <Col span={12}>
                  申请门店：
                  {props.Detail?.target}
                </Col>
              </>
            ) : (
              <>
                <Col span={6}>
                  调拨方：
                  {props.Detail?.source}
                </Col>
                <Col span={12}>
                  申请门店：
                  {shortName}
                </Col>
              </>
            )}
            <Col span={6}>业务部门：{props.Detail?.departmentName}</Col>
            <Col span={6}>
              业务人员：
              {tenantId == chainId
                ? props.Detail?.sourceUserName
                : props.Detail?.userName}
            </Col>
            <Col span={6}>供应商：{props.Detail?.supplierName}</Col>
          </Row>
          <Row>
            {props?.Detail?.storehouseTag == 200 && tenantId != chainId ? (
              <>
                <Col
                  span={23}
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                >
                  <Form.Item label='仅查看当前供应商的品种'>
                    <Switch
                      checkedChildren='开启'
                      unCheckedChildren='关闭'
                      checked={normalGysNameFlag}
                      onChange={(v: any) => {
                        setNormalGysNameFlag(v)
                        localStorage.setItem('normalGysName', v)
                      }}
                    />
                  </Form.Item>
                </Col>
              </>
            ) : (
              <></>
            )}
          </Row>
        </>
      )}
    </>
  )
}
